export const IGNORED = "IGNORED"
export const NEW = "NEW"
export const EMPTY = "EMPTY"
